/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/require-default-props */
import React, { useContext } from 'react';
import { AppContext } from '@thd-nucleus/app-render';
import { arrayOf, element, shape, oneOfType, func } from 'prop-types';
const DisplayOnCustomer = _ref => {
  let {
    children,
    middlewareProps
  } = _ref;
  const {
    instance
  } = useContext(AppContext);
  const {
    customer
  } = instance || {};
  const {
    type = 'b2c',
    display = 'show'
  } = middlewareProps;

  // b2c && display
  if (display === 'show' && type !== (customer === null || customer === void 0 ? void 0 : customer.type)) return null;
  return children({
    props: {}
  });
};
DisplayOnCustomer.propTypes = {
  children: func.isRequired,
  props: shape({}).isRequired,
  middlewareProps: shape({})
};
DisplayOnCustomer.displayName = 'DisplayOnCustomer';
DisplayOnCustomer.dataModel = {};
export { DisplayOnCustomer };
//# sourceMappingURL=DisplayOnCustomer.js.map